<template>
    <v-navigation-drawer
    v-model="$store.state.info_drawer"
      right
      absolute
      floating
      id="va-info-drawer"
    >
    <div class="pa-1">
      <v-card elevation="0">
        <v-toolbar dense elevation="1" tile>Learn More...
          <v-spacer/>
          <v-btn fab x-small elevation="1" color="warning" @click="setDrawer()"><v-icon>mdi-close</v-icon></v-btn>
        </v-toolbar>
        <v-card-text class="md-font">
          <div class="text-h6 mb-4">What is Product Properties?</div>
          <v-divider class="mb-3"/>
          <p>Product properties refer to the specific characteristics, features, or attributes that define a product.</p> 
          <p>
                  These properties can vary depending on the type of product (physical goods, digital products, services, etc.)
                  and can be used to describe its functionality, design, quality, and other important aspects.
          </p>
          <p>ex. Properties (Automotive):
            <br/>Year Model, Make, Color, Body Type, ect...
          </p>

        </v-card-text>
      </v-card>

    </div>
     

    </v-navigation-drawer>

</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data () {
      return {
      }
    },
    computed: {
       
    },
    methods: {
      ...mapMutations(['setInfoDrawer']),
        setDrawer(){
          this.setInfoDrawer(false)
        }
    }
  }
</script>